import React from 'react';
import { Star, Shield } from 'lucide-react';
import type { UserPet } from '../../types/pets';
import type { UserItem } from '../../types/items';

interface BattlePetProps {
  pet: UserPet;
  items: UserItem[];
  position: 'top' | 'bottom';
  isActive: boolean;
}

export function BattlePet({ pet, items, position, isActive }: BattlePetProps) {
  return (
    <div className={`flex ${position === 'top' ? 'flex-col' : 'flex-col-reverse'} items-center gap-4`}>
      {/* Pet Image */}
      <div className={`
        relative w-48 h-48 rounded-xl overflow-hidden
        ${isActive ? 'ring-2 ring-yellow-400 animate-pulse' : ''}
      `}>
        <img
          src={pet.imageUrl}
          alt={pet.name}
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
      </div>

      {/* Pet Info */}
      <div className="text-center space-y-2">
        <div className="flex items-center justify-center gap-2">
          <span className="text-lg font-bold text-white">{pet.name}</span>
          <Star className={`w-4 h-4 ${
            pet.rarity === 'legendary' ? 'text-yellow-400' :
            pet.rarity === 'epic' ? 'text-purple-400' :
            pet.rarity === 'rare' ? 'text-blue-400' :
            pet.rarity === 'uncommon' ? 'text-green-400' :
            'text-gray-400'
          }`} />
        </div>
        <div className="text-sm text-gray-400">
          Level {pet.level} {pet.type}
        </div>
      </div>

      {/* Active Items */}
      {items.length > 0 && (
        <div className="flex gap-2">
          {items.map((item) => (
            <div
              key={item.id}
              className="w-8 h-8 bg-gray-800 rounded-lg flex items-center justify-center"
              title={item.name}
            >
              <Shield className="w-4 h-4 text-yellow-400" />
            </div>
          ))}
        </div>
      )}
    </div>
  );
}